import { Component, OnInit, ViewChild } from '@angular/core';

import { Popup } from 'ng2-opd-popup';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin';
import Swal from 'sweetalert2';

declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Agent inscrit. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-statistique-global',
  templateUrl: './statistique-global.component.html',
  styleUrls: ['./statistique-global.component.scss']
})
export class StatistiqueGlobalComponent implements OnInit {
  @ViewChild('popup5') popup5: Popup;
  constructor(private router: Router, public adminService: AdminService) { 

  }

  ngOnInit() {
  }


  open(id:any){

    if(id==2){
      Swal.fire({
        title: 'Consultations effectuées',
        icon: 'info',
        text: 'Nombre de consultations effectuées par médecin depuis la date de prise de service jusqu\'à ce jour.',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn         
          success_message.show();
          this.router.navigate(['statistic-global-cons']);
         
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }else  if(id==3){
      Swal.fire({
        title: 'Statistique de repos médical',
        icon: 'info',
        text: 'Nombre de repos médical pris par agent depuis la date de prise de service jusqu\'à ce jour.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message2.show();
          this.router.navigate(['statistic-global-repos']);    
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }else  if(id==4){
      Swal.fire({
        title: 'Statistique de Remboursement',
        icon: 'info',
        text: 'Nombre de dossiers de remboursement traités par  agent depuis la date de prise de service jusqu\'à ce jour.',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message3.show();  
          this.router.navigate(['statistic-global-rembours']);    
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });

    }




   

  }

  Agent_et_famille() {
    Swal.fire({
      title: 'Agents inscrits',
      icon: 'info',
      text: 'Liste des agents du MEF et leur famille par Direction inscrits au niveau du CMS.',
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Voir!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        success_message4.show();  
        this.router.navigate(['statistic-global-agent']);    
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });
  }

  Agent_et_famille2() {
    this.popup5.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#A0DE4F",
      showButtons: true,
      animationDuration: 1.5,
      header: "Créer rendez-vous en ligne",
      widthProsentage: 40,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }

  ConfirmAgent(){
    this.router.navigate(['statistic-global-agent']);  
  }

}
